import arcFeatures from '@wpmedia/arc-features'

import flags from './flags'

export async function getFeatures() {
  const features = await arcFeatures.instance({ flags })
  return features
}
